import header from "@/layout/header.vue";

export const workplace = {
  path: "/workplace",
  components: {
    default: () => import("@/views/workplace.vue"),
    header,
  },
  meta: {
    menu: true,
    header: false,
  },
  redirect: "/workplace/history",
  children: [
    {
      path: "/",
      name: "workplace",
      component: () => import("@/views/workplace.vue"),
    },
    {
      path: "history",
      name: "history",
      component: () => import("@/views/workplace/history.vue"),
    },
    {
      path: "exibition",
      name: "exibition",
      component: () => import("@/views/workplace/exibition/exibition.vue"),
      meta: {
        menu: true,
        header: false,
      },
    },
    {
      path: "exibitionList",
      name: "exibitionList",
      component: () => import("@/views/workplace/exibition/exibitionList.vue"),
      meta: {
        menu: false,
        header: true,
        title: "选择模板",
        back: true,
        keepAlive: true,
      },
    },
    {
      path: "echarts",
      name: "echarts",
      component: () => import("@/views/workplace/echarts.vue"),
      meta: {
        menu: false,
        header: true,
        back: true,
      },
    },
    {
      path: "exibitionDetails/:id",
      name: "exibitionDetails",
      component: () =>
        import("@/views/workplace/exibition/exibitionDetails.vue"),
      meta: {
        menu: false,
        header: true,
        title: "基本信息",
        requiresAuth: false,
        back: {
          url: "/workplace/exibition",
        },
      },
    },
    {
      path: "exbitionDetails",
      name: "exbitionDetails",
      component: () =>
        import("@/views/workplace/exibition/exibitionDetails.vue"),
      meta: {
        menu: false,
        header: true,
        requiresAuth: false,
        title: "基本信息",
        back: true,
      },
    },
    // {
    //   path: "exbitionDetails",
    //   name: "exbitionDetails",
    //   component: () =>
    //     import("@/views/workplace/exibition/exibitionDetails.vue"),
    //   meta: {
    //     menu: false,
    //     header: true,
    //     requiresAuth: false,
    //     title: "基本信息",
    //     back: true,
    //   },
    // },
    {
      path: "hall",
      name: "hall",
      // component: { template: "<router-view></router-view>" },
      children: [
        {
          path: "hallList",
          name: "hallList",
          component: () => import("@/views/workplace/hall/list.vue"),
          meta: {
            menu: true,
            header: true,
            title: "",
          },
        },
        {
          path: "createHall",
          name: "createHall",
          component: () => import("@/views/workplace/hall/create.vue"),
          meta: {
            menu: false,
            header: true,
            title: "",
            back: true,
          },
        },
        {
          path: "compileHall",
          name: "compileHall",
          component: () => import("@/views/workplace/hall/compileHall.vue"),
          meta: {
            menu: false,
            header: true,
            back: true,
          },
        },
        {
          path: "bindExbition/:id",
          name: "bindExbition",
          component: () => import("@/views/workplace/hall/bindExbition.vue"),
          meta: {
            menu: false,
            header: true,
            back: true,
          },
        },
        {
          path: "hallDetails/:id",
          name: "hallDetails",
          alias: "/h/:id",
          component: () => import("@/views/workplace/hall/hallDetails.vue"),
          meta: {
            menu: false,
            header: true,
            back: true,
          },
        },
      ],
    },

    {
      path: "teamwork",
      name: "teamwork",
      component: () => import("@/views/workplace/teamwork.vue"),
      meta: {
        menu: true,
        header: false,
      },
    },
    {
      path: "resource",
      name: "resource",
      component: () => import("@/views/workplace/resource/index.vue"),
      meta: {
        menu: true,
        header: false,
      },
    },
    {
      path: ":pathMatch(.*)*",
      name: "404",
      components: {
        default: () => import("@/views/404.vue"),
      },
      meta: {
        menu: true,
        title: "暂未开放",
      },
    },
  ],
};
